var _rect, _tspan;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStatusLate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 26,
    viewBox: "0 0 18.521 6.8792",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.2479e-7,
    y: 3.4748e-7,
    width: 18.521,
    height: 6.8792,
    ry: 1.6755,
    fill: "#abb0b4"
  })), /*#__PURE__*/React.createElement("text", {
    transform: "scale(1.0209 .97949)",
    x: 5.5043659,
    y: 4.5943241,
    fill: "#ffffff",
    fontFamily: "sans-serif",
    fontSize: "3.0285px",
    letterSpacing: "0px",
    strokeWidth: 0.075714,
    wordSpacing: "0px",
    style: {
      lineHeight: 1.25
    },
    xmlSpace: "preserve"
  }, _tspan || (_tspan = /*#__PURE__*/React.createElement("tspan", {
    x: 5.5043659,
    y: 4.5943241,
    fill: "#ffffff",
    fontFamily: "sans-serif",
    fontWeight: "bold",
    strokeWidth: 0.075714
  }, "LATE"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatusLate);
export default __webpack_public_path__ + "static/media/status_late.6fb40e7c2f8e24b924e91e40d1c8ec58.svg";
export { ForwardRef as ReactComponent };